import React, {Component} from 'react';
import styles from './styles.less';

export default class Icon extends Component {
	render() {
		let className = this.props.className ? this.props.className.concat(' ') : '';
		className = className.concat(styles['bsui-icon']);

		if (this.props.name)
		{
			className += ' ' + styles['bsui-icon_' + this.props.name];
		}

		const onClick = typeof this.props.onClick === 'function'
			? this.props.onClick
			: () => {};

		return <span className={className} onClick={onClick} />;
	}
}